import { ReactNode } from 'react';
import styled from 'styled-components';

import { Arrow } from 'shared/icons/Arrow';
import { variableFontRegular } from 'styles/theme/text';

export interface IUpdate2022VariantSectionContentHeaderProps {
  'data-qa'?: string;
  className?: string;
  children?: ReactNode;
  title?: string;
  onBack?: () => void;
}

export const Update2022VariantSectionContentHeader = ({
  children,
  title,
  onBack,
  ...rest
}: IUpdate2022VariantSectionContentHeaderProps) => {
  return (
    <Update2022VariantSectionContentHeader.Root {...rest}>
      {onBack && (
        <Update2022VariantSectionContentHeader.BackButton onClick={onBack}>
          <Arrow fill="currentcolor" direction="left" />
        </Update2022VariantSectionContentHeader.BackButton>
      )}

      <Update2022VariantSectionContentHeader.Title>
        {title ?? children}
      </Update2022VariantSectionContentHeader.Title>
    </Update2022VariantSectionContentHeader.Root>
  );
};

Update2022VariantSectionContentHeader.Root = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns:
    [start] max(32px, 15%) [middle-left] 1fr [middle-right] max(32px, 15%)
    [end];
  grid-template-rows: [top] auto [bottom];

  padding: 16px 16px;
  ${variableFontRegular({ size: '11.5px', height: '16px' })}
`;

Update2022VariantSectionContentHeader.BackButton = styled.button`
  grid-row: top / bottom;
  grid-column: start / middle-left;
  padding: 0px;
  text-align: start;
`;

Update2022VariantSectionContentHeader.Title = styled.span`
  width: 100%;
  text-align: center;
  grid-row: top / bottom;
  grid-column: middle-left / middle-right;
`;
